import { render, staticRenderFns } from "./invoice-create.vue?vue&type=template&id=2484bef4&scoped=true"
import script from "./invoice-create.vue?vue&type=script&lang=js"
export * from "./invoice-create.vue?vue&type=script&lang=js"
import style0 from "./invoice-create.vue?vue&type=style&index=0&id=2484bef4&prod&scoped=true&lang=css"
import style1 from "./invoice-create.vue?vue&type=style&index=1&id=2484bef4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2484bef4",
  null
  
)

export default component.exports